<div
  TsFieldStyling
  [fieldBackgroundColor]="fieldStyling().color"
  [fieldBold]="fieldStyling().is_bold"
  [targetStylingClass]="commonTargetStylingClass"
  class="flex-auto gt-xs:pr-3 w-full mb-2"
>
  @if (fieldDef.meta?.value_hidden) {
    <ts-input [label]="fieldDef.label" [formControl]="redactedControl" [blurred]="true" />
  } @else {
    <ts-input
      [label]="fieldDef.label"
      [formControl]="valueControl"
      (click)="edit()"
      (keyup.enter)="onBlur()"
      (blur)="onBlur()"
    >
      <span tsInputSuffix>%</span>
    </ts-input>
  }
</div>
